import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";

export const shootCostingUrlKey = "costing_id";

export const shootCostingItemsAssocObjKey = "shootCostingItems";
export const costingShootAssocObjKey = "costingShoot";

export const costingColumns = {
	shoot_costing_id: {
		name: "Shoot Costing Id",
		key: "shoot_costing_id",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: 0,
	},
	product_count: {
		name: "Product Count",
		key: "product_count",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 2,
		group: "",
		placeholder: "",
		default_value: 0,
	},
};

export const filterRequiredStyleColumns = (styleAllAttributesObj) => {
	return Object.keys(costingColumns)?.reduce((acc, col) => {
		if (styleAllAttributesObj[col]) acc.push({ ...styleAllAttributesObj[col], constraints: costingColumns[col] });
		return acc;
	}, []);
};

export const totalCostColumn = {
	name: "Total Cost",
	key: "total_cost",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.DECIMAL.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};
export const totalQtyColumn = {
	name: "Total Qty",
	key: "total_qty",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.NUMBER.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};

export const CreatedAtColumn = {
	name: "Created At",
	key: "created_at",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.DECIMAL.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: 0,
};

export const DisabledBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: grey[100] }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string"
					? row[field]?.split("_").join(" ")
					: typeof row[field] === "number"
					? roundDecimalValueUptoTwoDigit(row[field])
					: row[field]}
			</span>
		</Box>
	);
};
export const WhiteBgBox = ({ field, row }) => {
	return (
		<Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" sx={{ background: "white" }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string"
					? row[field]?.split("_").join(" ")
					: typeof row[field] === "number"
					? roundDecimalValueUptoTwoDigit(row[field])
					: row[field]}{" "}
			</span>
		</Box>
	);
};
export const TotalBox = ({ field, row }) => {
	return (
		<Box
			width="100%"
			height="100%"
			display="flex"
			alignItems="center"
			justifyContent="center"
			sx={{ background: grey[300], fontWeight: 600 }}>
			<span style={{ textTransform: "uppercase" }}>
				{typeof row[field] === "string"
					? row[field]?.split("_").join(" ")
					: typeof row[field] === "number"
					? roundDecimalValueUptoTwoDigit(row[field])
					: row[field]}{" "}
			</span>
		</Box>
	);
};

export const removeKeyFromArrOfObj = (arr, column) => {
	return arr.reduce((acc, row) => {
		let obj = { ...row };
		if (obj[column]) delete obj[column];
		acc.push(obj);
		return acc;
	}, []);
};
